<template>
    <router-view
    />
  </template>

<script>

export default {
  computed: {
  },
}
</script>
